/** @jsxImportSource @emotion/react */
import { Box, Button, CircularProgress, Grid, Typography, useTheme } from '@mui/material'
import { CenteredBox } from '@app/components/ui/CenteredBox/CenteredBox'
import { contentAreaStyles } from './WorkspacesDialog.styles'
import { DialogDescription, DialogHeader, DialogTitle } from '@app/components/ui/Dialog/Dialog'
import { useNavigate } from 'react-router-dom'

interface WorkspaceDialogLoadingProps {
  isError?: boolean
  heading?: string
  description?: string
}

const WorkspacesDialogLoading = ({
  isError,
  heading,
  description,
}: WorkspaceDialogLoadingProps) => {
  const theme = useTheme()
  const navigate = useNavigate()

  if (isError) {
    return (
      <Box css={contentAreaStyles(theme)}>
        <DialogHeader>
          <DialogTitle>{heading}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <CenteredBox height={300}>
          <Grid
            container
            direction="column"
            spacing={2}
            alignItems="center"
            justifyContent="center"
            gap={5}
          >
            <Typography variant="body1" color={theme.palette.error.main}>
              Error loading Workspace. Please try again.
            </Typography>
            <Button variant="outlined" size="small" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </Grid>
        </CenteredBox>
      </Box>
    )
  }

  return (
    <Box css={contentAreaStyles(theme)}>
      <DialogHeader>
        <DialogTitle>{heading}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>
      <CenteredBox height={300}>
        <CircularProgress color="primary" size="60px" />
      </CenteredBox>
    </Box>
  )
}

export default WorkspacesDialogLoading
